module.exports = __webpack_public_path__ + "static/media/KaTeX_Size4-Regular.f961545c.woff";